import { dayKey } from './reporting'

export const DRIVER_CLASSES = ['C', 'LR', 'MR', 'HR', 'HC', 'MC', 'R', 'RE']
export const TICKET_OPTIONS = [
    { value: 'white_card', label: 'White card' },
    { value: 'traffic_control', label: 'Traffic control / management' },
    ...['Forklift', 'Hoist', 'Dogging', 'Rigging', 'Crane', 'Scaffold'].map(name => ({ value: `high_risk:${name}`, label: name })),
    { value: 'contractor', label: 'Contractor licence' },
]
export const recordedDay = value => {
    const key = dayKey(value)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return ''
    const date = new Date(`${key}T00:00:00Z`)
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === key ? key : ''
}
export const monthsHeld = (issuedOn, asOf = new Date()) => {
    const issued = recordedDay(issuedOn), today = recordedDay(asOf)
    if (!issued || !today || issued > today) return null
    const [year, month, day] = issued.split('-').map(Number)
    const [currentYear, currentMonth, currentDay] = today.split('-').map(Number)
    const anniversaryDay = Math.min(day, new Date(Date.UTC(currentYear, currentMonth, 0)).getUTCDate())
    return (currentYear - year) * 12 + currentMonth - month - (currentDay < anniversaryDay ? 1 : 0)
}
export const ticketRecords = worker => {
    const records = []
    if (worker.hasWhiteCard || worker.whiteCardLicenseNo || worker.whiteCardStartDate) records.push({ type: 'white_card', label: 'White card', issuedOn: recordedDay(worker.whiteCardStartDate), expiresOn: '' })
    if (worker.hasTrafficControl || worker.trafficControlLicenseNo || worker.trafficControlStartDate) records.push({ type: 'traffic_control', label: 'Traffic control / management', issuedOn: recordedDay(worker.trafficControlStartDate), expiresOn: recordedDay(worker.trafficControlExpiryDate) })
    const highRisk = Array.isArray(worker.highRiskClass) ? worker.highRiskClass : []
    for (const name of highRisk) records.push({ type: `high_risk:${name}`, label: name, issuedOn: highRisk.length === 1 ? recordedDay(worker.highRiskStartDate) : '', expiresOn: recordedDay(worker.highRiskExpiryDate), sharedIssueDate: highRisk.length > 1 })
    if (worker.hasContractorLicence || worker.contractorLicenseNo || worker.contractorStartDate) records.push({ type: 'contractor', label: 'Contractor licence', issuedOn: recordedDay(worker.contractorStartDate), expiresOn: recordedDay(worker.contractorExpiryDate) })
    // Explicit per-ticket dates take precedence over the shared high-risk licence date.
    const merged = new Map(records.map(row => [row.type, row]))
    for (const row of worker.jobMarketQualifications?.tickets || []) {
        const type = row.type?.startsWith('custom:') ? `custom:${String(row.label || '').trim().toLowerCase().normalize('NFKC').replace(/\s+/g, ' ')}` : row.type
        merged.set(type, { ...row, type, issuedOn: recordedDay(row.issuedOn), expiresOn: recordedDay(row.expiresOn), sharedIssueDate: false })
    }
    return [...merged.values()]
}
export const qualificationOptions = workers => {
    const options = new Map(TICKET_OPTIONS.map(row => [row.value, row]))
    workers.forEach(worker => ticketRecords(worker).forEach(row => { if (!options.has(row.type)) options.set(row.type, { value: row.type, label: row.label }) }))
    return [...options.values()]
}
export const matchesQualifications = (worker, filters, asOf = new Date()) => {
    const today = recordedDay(asOf)
    const records = ticketRecords(worker)
    const requirements = filters.tickets || []
    if (!requirements.every(requirement => records.some(record => {
        if (record.type !== requirement.type) return false
        if (filters.excludeExpired && record.expiresOn && record.expiresOn < today) return false
        if (record.issuedOn && record.issuedOn > today) return false
        const months = monthsHeld(record.issuedOn, asOf)
        return Number(requirement.minMonths || 0) === 0 || (months !== null && months >= Number(requirement.minMonths))
    }))) return false
    const driver = worker.jobMarketQualifications?.driverLicence || { status: 'unknown', classes: [] }
    if (filters.driver === 'held' && driver.status !== 'held') return false
    if (filters.driver === 'none' && driver.status !== 'none') return false
    if (filters.driver === 'unknown' && driver.status !== 'unknown') return false
    if (filters.driverClass && (driver.status !== 'held' || !(driver.classes || []).includes(filters.driverClass))) return false
    if ((filters.driver === 'held' || filters.driverClass) && filters.excludeExpired && recordedDay(driver.expiresOn) && recordedDay(driver.expiresOn) < today) return false
    return true
}
